<template>
  <div v-cloak class="conten bg-white">
    <div>
        <ul class='row ft12 gary-2 tabBox '>
            <li @click="selectTab(index)" v-for="(item,index) in list" :key="index" :class="{'orangered':cur == index}">
                <span>{{item.title}}</span>
            </li>
        </ul>
        <ul class='bg-white padding0-15' v-if="courseList.length>0">
            <li class='padding20 bg-white courseBox margin15-bottom' v-for="(item,index) in courseList" :key='index'>
                <div @click="selectCourse(index)">
                    <p class='col_65 ft12'>订单编号:{{item.orderNumber}}</p>
                    <p v-if='item.state == 1' class='col_65 ft12'>支付时间：请于{{item.orderEndDate}}之前完成支付</p>
                    <p v-if="item.state == 2" class='col_65 ft12'>下单时间：{{item.orderDate}}</p>
                    
                    <p class="ft16 col_21 padding10-0">{{item.courseTitle}}</p>
                    <p class="col_87 ft12 text-right padding20-bottom">¥{{item.coursePrice}}</p>
                </div>
                <div class="lineF4"></div>
                
                <p v-if='item.state == 1' class="ft12 gray-8 row cen-between padding10-top">
                    <span>
                        <span class="ft14 col_21"> 应付金额：</span>
                        <span class="ft14 orangered"> ¥{{item.practicalPrice}}</span>
                    </span>
                    <span class="payBtn ft14 white text-center" @click="goPay(index)">立即支付</span>
                </p>
                <p v-if="item.state == 2" class="ft12 gray-8 row cen-between padding10-top">
                    <span>
                        <span class="ft14 col_21"> 应付金额：¥{{item.practicalPrice}}</span>
                    </span>
                    <span class="learnBtn ft14 orangered text-center" @click="goLearn">去学习</span>
                </p>
            </li>
        </ul>
        <order-default v-else></order-default>
    </div>
   <Gohome  @click="goHome"></Gohome>
  </div>
</template>
 
<script>
import { CacheModule } from '@/utils/commonUtils.js'
import orderDefault from '@/components/default/orderDefault'
import { getOrderCenter } from '@/model/order/orderServer';
import Gohome from '@/components/gohome/gohome'
export default {
  name: 'learningCenter',
  data(){
      return {
          cur:0,
          courseList:[],
          list:[
          ],
          
      }
  },
  components: {
      orderDefault,
      Gohome
  },
  created(){
    let params = {
    "loginname":CacheModule.get('loginPhone')
    }
    if(!CacheModule.get('loginPhone')){
          this.goHome()
    }
      
    getOrderCenter(params).then(data =>{
        this.list = data.data
        this.courseList = this.list[this.cur].list
    }).catch(error => {
        if(error.retuCode == 5004){
            this.goHome()
        }
    })
  },
  methods: {
    goLearn(){
        this.$router.push({
            path: '/learning',
        })
    },
    goPay(e){
        window.location.href = `http://m.xzjy365.com/pay?cid=${this.courseList[e ].cid}`
    },
    goHome() {
        this.$router.replace({
            path: '/login',
        })
    },
    selectTab(index){
        this.cur = index
        this.courseList = {}

        this.courseList = this.list[index].list
    },
    selectCourse(index){
        this.$router.push({
            path: '/details',
            query: {
                cid:this.courseList[index].cid
            }
        })
    }
  }
}
</script>
<style scoped lang="less">

.lineF4 {
  width: 100%;
  height: 2px;
  background-image: linear-gradient(0deg, #F4F4F4 50%, transparent 50%);
}
.col_65{
    color: #656565
}
.col_21{
    color: #212121;
}
.col_87{
    color: #878787
}
.payBtn{
    width: 104/20rem;
    height: 32/20rem;
    line-height: 32/20rem;
    display: inline-block;
    background:linear-gradient(90deg,rgba(253,123,48,1),rgba(239,129,67,1));
    box-shadow:0px 0px 15/20rem 1px rgba(255, 0, 93, 0.35);
    border-radius:16/20rem;
}
.learnBtn{
    width: 104/20rem;
    height: 32/20rem;
    line-height: 32/20rem;
    display: inline-block;
    background:rgba(255,255,255,1);
    border:1px solid rgba(253,123,48,1);
    border-radius:16/20rem;

}
.tabBox{
    height: 38/20rem;
    padding: 0 .75rem 0 25/20rem;
    line-height:38/20rem;
    li{
        padding-right: 1.5rem;
    }
}
.courseBox{
    // box-shadow:0px 0px .2rem 0px rgba(0, 0, 0, 0.25);
    box-shadow:0px 0px 8px 0px rgba(0, 0, 0, 0.12);
    border-radius:5px;
}
</style>